<template>
  <div :class="wrapperClass" style="background-color: #ededed;">
    <profile-header></profile-header>
    <div class="container contact-container">
      <TitleContainer :title="title" :isExtraWidth="extraWidth" v-if="showTitleContainer"/>
        <!-- <div class="container content-head" :class="dynamicClass" style="background: #EDEDED; height: 50px; border-bottom: 1px solid #B3B3B3">
            <h2 style="padding: 10px 0px; font-size: 20px;">登録情報の編集</h2>
        </div> -->
        <div class="user-content">
          <div style="margin-bottom: 20px !important;">
            <div class="my-auto w-100 main-area">
              <div class="profile-detail">
                <div class="profile-detail-block">
                  <!-- Content of the profile-detail block -->
                  <slot></slot>
                </div>
              </div>
            </div>
          </div>
        </div>
        <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import ProfileHeader from "@/components/header.vue";
import TitleContainer from "./TitleContainer.vue";
export default {
  name: 'UserWrapper',
  components: { ProfileHeader, TitleContainer },
  props: {
    extraWidth: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '一覧'
    },
    showTitleContainer: {
      type: Boolean,
      default: true
    }
  },
  // data() {
  //   return {
  //     dynamicClass: this.getClassForScreenSize()
  //   };
  // },
  computed: {
    wrapperClass() {
      return 'user-wrapper w-100';
    }
  },
  // mounted() {
  //   window.addEventListener('resize', this.updateClassForScreenSize);
  // },
  // beforeDestroy() {
  //   window.removeEventListener('resize', this.updateClassForScreenSize);
  // },
  // methods: {
  //   updateClassForScreenSize() {
  //     // Update the dynamic class based on screen size
  //     this.dynamicClass = this.getClassForScreenSize();
  //   },
  //   getClassForScreenSize() {
  //     if (this.extraWidth && window.innerWidth >= 1024) {
  //       return 'mx-5';
  //     } else {
  //       return '';
  //     }
  //   }
  // }
};
</script>
<style scoped>
@media (max-width: 1024px){
  .container.contact-container {
    padding: 8px !important;
  }
}

.contact-container {
  background-color: #ededed;
}
</style>
